import React from "react";
import type { MeetingState } from "../types";

interface MeetingStateBadgeProps {
  readonly state: MeetingState;
}

const LABELS: Readonly<Record<MeetingState, string>> = {
  live: "Meeting in progress",
  ended: "Meeting ended",
  pending: "Meeting not started"
};

/** The dot is decorative; the label carries the meaning (WCAG 1.4.1). */
export function MeetingStateBadge({
  state
}: MeetingStateBadgeProps): React.JSX.Element {
  return (
    <span className="live-pill la-badge">
      <span className="dot la-badge__dot" aria-hidden="true" />
      {LABELS[state]}
    </span>
  );
}
